import React from 'react'
import PropTypes from 'prop-types'
import styles from '../Tab/Tab.module.scss'
import Dropdown from '../Dropdown/Dropdown'

const Tab = (props) => {
  const { 
    items,
    onSelectTab,
    selectedTab,
    isMobile,
    name,
    isFormValid,
  } = props

  const handleTabChange = (index) => {
    isFormValid && onSelectTab(index)
  }

  const renderTab = () => items.map((item, index) => (
    <ul key={index} className={selectedTab === index ? styles.active : undefined}>
        <a onClick={handleTabChange.bind(this, index)}>{item}</a> {//eslint-disable-line
      }
    </ul>
  ))
  
  return (
    <div className={styles.Tab}>
      {
        isMobile ? 
          <Dropdown 
            options={items}
            name={name || 'tabDropdown'} 
            selectedItem={selectedTab}
            onSelectItem={handleTabChange} /> :
          <div>
            <hr />
            <li className={styles.tabList}>
              {
                renderTab()
              }
            </li>
          </div> 
      }
    </div>
  )
}

Tab.propTypes = {
  isFormValid: PropTypes.bool,
  items: PropTypes.array.isRequired,
  onSelectTab: PropTypes.func.isRequired,
  selectedTab: PropTypes.number,
  isMobile: PropTypes.bool.isRequired,
  name: PropTypes.string,
}

Tab.defaultProps = {
  isFormValid: true,
  selectedTab: 0,
  name: ''
}

export default Tab



// WEBPACK FOOTER //
// ./src/components/Shared/Tab/Tab.jsx